if ($('#map').length) {
    /* Custom Scrollbar */
    $('.scrollbar-light').scrollbar();

    /*
    Categories:
        FCS = California Coast Branches
        ESC = Shared Branches
        ATMSF = ATM Surcharge Free
        ATMDP = ATM Accept Deposits
    */

    window.onload = function () {

        //Global Variables
        var extmap,
            latLng,
            //userpin,
            lat = 33.1347205, //Default
            long = -117.1050825, //Default
            markers = [],
            bounds,
            mapCenterLat = 33.1347205,
            mapCenterLng = -117.1049967,
            hours,
            setHours,
            zoomLevel = 11,
            locFilters = 'FCS ESC ATMSF ATMDP',
            infoWindow = new google.maps.InfoWindow();

        //Browser GeoLocation on Page Load
        function onPositionReceived(position) {
            lat = position.coords['latitude'];
            long = position.coords['longitude'];
            console.log("user position: " + lat, long);

            latLng = new google.maps.LatLng(lat, long);

            extmap.setCenter(latLng);

            //Update Map Bounds and Map Center
            userLocMapBounds(extmap);

            locFilters = 'FCS ESC ATMSF ATMDP';

            //Locations Data
            getData();
        }

        //Autocomplete location
        var input = document.getElementById('enterCurrentLoc');
        var autocomplete = new google.maps.places.Autocomplete(input);

        // Check to see if the browser supports the GeoLocation API.
        if (navigator.geolocation) {
            // Get user location
            navigator.geolocation.getCurrentPosition(onPositionReceived);
        } else {
            // Print out a message to the user.
            console.log('Your browser does not support GeoLocation');
        }

        //Map Bounds
        function userLocMapBounds(extmap) {
            //Map Bounds
            bounds = extmap.getBounds();

            //Map Center
            mapCenterLat = extmap.getCenter().lat();
            mapCenterLng = extmap.getCenter().lng();
        }

        //Google Init Map
        function initMap(latLng) {
            // Set map options
            var mapOptions = {
                zoom: zoomLevel,
                center: {
                    lat: lat,
                    lng: long
                },
                disableDefaultUI: true,
                zoomControl: true,
                panControl: true,
                streetViewControl: false,
                rotateControl: true
            };

            // Create the map
            extmap = new google.maps.Map(document.getElementById('map'), mapOptions);

            //Locations Data
            getData();

            //Panning map bounds
            mapBounds();

            //WCGA Map Updates
            google.maps.event.addListenerOnce(extmap, 'tilesloaded', function () {
                setTimeout(function () {
                    $('.gm-style > div').removeAttr('tabindex');
                }, 2000);
                $('.gm-style').find('iframe').attr('title', 'Google Interactive Map');
            });

        }
        initMap();

        //Get Map Bounds on Drag
        function mapBounds() {
            //Find the new map bounds only when panning / zooming stopped
            google.maps.event.addListener(extmap, 'dragend', function () {
                //Map Bounds & Center
                userLocMapBounds(extmap);

                //Delete all markers
                deleteMarkers();

                //Get new data
                getData();
            });
        }

        //Get Data
        function getData() {

            let URL = 'https://mobileapi.locatorsearch.com/LocatorSearchAPI.asmx/FindLocations?UserName=39514221&Password=39514221-D8C2-4684-84D9-D5F66E308913&AddressLine=&City=&State=&PostalCode=&Country=&Latitude=' + mapCenterLat + '&Longitude=' + mapCenterLng + '&Type=' + locFilters + '&Offset=25';

            $.ajax({
                type: "get",
                url: URL,
                dataType: "xml",
                success: function (data) {
                    /* handle data here */
                    $(".loc-list ").empty();

                    console.log(data);

                    $(data).find('locations location').each(function () {
                        let locID = $(this).find('attribute[key="LocationID"]').text();
                        let iconType = $(this).find('attribute[key="MapIcon"]').text();
                        let locType = $(this).find('attribute[key="LocationType"]').text();
                        let locTitle = $(this).find('attribute[key="LocationName"]').text();
                        let surcharge = $(this).find('attribute[key="SurchargeFree"]').text();
                        let deposit = $(this).find('attribute[key="AcceptDeposit"]').text();
                        let locAddress = $(this).find('address street').text();
                        let locCity = $(this).find('address city').text();
                        let locState = $(this).find('address state').text();
                        let locZip = $(this).find('address zip').text();
                        let locDistance = $(this).attr('distance');

                        // Get Lat/Lng for each location
                        let latitude = $(this).find('attribute[key="Latitude"]').text();
                        let longitude = $(this).find('attribute[key="Longitude"]').text();
                        latLng = new google.maps.LatLng(latitude, longitude);

                        if (iconType == '1.png') {
                            if (deposit == 'Deposit Taking') {
                                iconType = '1.png';
                            } else {
                                iconType = '2.png';
                            }
                        }

                        var marker = new google.maps.Marker({
                            position: latLng, //set coords
                            title: locTitle, //set title
                            icon: "/Static/dist/images/" + iconType, //set the custom marker
                            category: locType,
                            id: locID,
                        });

                        //Set markers to the map
                        marker.setMap(extmap);
                        ;
                        //Add markers to markers array so we can keep track
                        markers.push(marker);

                        (function (marker, data) {
                            google.maps.event.addListener(marker, "click", function (e) {
                                var mkpos = marker.getPosition();
                                infoWindow.setContent('<div class="loc-infowindow">' +
                                    '<div class="loc-type">' + locType + '</div>' +
                                    '<div class="loc-title">' + locTitle + '</div>' +
                                    '<div class="loc-address">' +
                                    locAddress + '<br/>' +
                                    locCity + ', ' + locState + ' ' + locZip +
                                    '</div>' +
                                    '<div class="loc-hours" style="display: none;">' +
                                    '<strong>Branch Hours</strong><br>' +
                                    //'<div style="whitespace:pre">' + data.hours.replace(/\\n/g, '<br />') + '</div>' +
                                    '</div>' +
                                    '<div class="loc-directions">' +
                                    //'<div class="distance">' + data.distance.toFixed() + 'mi</div>' +
                                    '<a class="external-google" href="http://maps.google.com/?daddr=' + locAddress + ' ' + locCity + ' ' + locState + ' ' + locZip + '" target="_blank" aria-label="Get directions to the ' + locTitle + ' branch">Get Directions</a>' +
                                    '</div>' +
                                    '</div>');
                                infoWindow.open(extmap, marker);

                            });
                        })(marker, data);

                        $("ul.loc-list").append('<li id="' + locID + '">' +
                            '<div class="loc-list-left">' +
                            '<div class="icon"><img src="/static/dist/images/' + iconType + '" /></div>' +
                            '<div class="loc-type">' + locType + '</div>' +
                            '<div class="loc-title">' + locTitle + '</div>' +
                            //$(this).find('attribute[key="MapIcon"]').text() +
                            '<p>' + locAddress + '<br>' + locCity + ' ' + locState + ' ' + locZip + '</p>' +
                            '</div>' +
                            '<div class="loc-list-right">' +
                            '<strong>' + locDistance + '</strong>' + ' miles | <a href="http://maps.google.com/?daddr=' + locAddress + ' ' + locCity + ' ' + locState + ' ' + locZip + '" target="_blank" aria-label="Get directions to the ' + locTitle + ' branch">Directions</a>' +
                            '</div>' +
                            '</li>');

                        if (locFilters === 'FCS') {
                            extmap.setZoom(9);
                        }

                        //Close open infowindow
                        google.maps.event.addListener(extmap, 'click', function () {
                            infoWindow.close();
                        });
                    });
                },
                error: function (xhr, status) {
                    /* handle error here */
                    console.log('something went wrong');
                }
            });
        }

        //Entering Address in text field and updating user location
        $('#getLocation').on('click', function (e) {
            getLocation(e);
        });

        $('#enterCurrentLoc').on('keypress', function (e) {
            if (e.which == 13) {
                getLocation(e);
            }
        });

        var getLocation = function (e) {
            var startingLocation = $('#enterCurrentLoc').val(),
                location = $('#enterCurrentLoc').attr('id');

            if (startingLocation == '') {
                $('#' + location + '-error').show();
                e.preventDefault();
            } else {
                $('#' + location + '-error').hide();
                $.ajax({
                    url: "https://maps.googleapis.com/maps/api/geocode/json?address=" + decodeURIComponent(startingLocation) + "&key=AIzaSyCpwflbT5FtylsEWlrPlTfra8riEijEY1c&libraries=geometry,places",
                    type: 'GET'
                }).done(function (data) {
                    lat = data.results[0].geometry.location.lat;
                    long = data.results[0].geometry.location.lng;
                    //Reset GoogleMaps Cords
                    latLng = new google.maps.LatLng(lat, long);
                    //Center Map to New Location
                    extmap.setCenter(latLng);

                    //Map Bounds & Center
                    userLocMapBounds(extmap);

                    extmap.setZoom(zoomLevel);

                    locFilters = 'FCS ESC ATMDP ATMSF';

                    //Get Data
                    getData(locFilters);

                });
            };
        };

        //Filter Map and HTML List based on selected radio button
        var $radios = $('input[name=location_option]').change(function () {
            var locationsFilters = [];
            $.each($("input[name='location_option']:checked"), function () {
                locationsFilters.push($(this).val());
            });
            //console.log("My favourite sports are: " + locationsFilters.join(", "));

            locFilters = locationsFilters.join(", ");
            console.log(locFilters);

            if (locationsFilters.length === 0) {
                locFilters = 'FCS ESC ATMDP ATMSF';
                extmap.setZoom(zoomLevel);
            }

            //Delete all markers
            deleteMarkers();
            //Run the new Data
            getData();

        });

        //Open infowindow from matching HTML link
        var locInfo = $('.loc-list');
        $(locInfo).on('click', '> *', function () {

            // get link data-title
            var titleToFind = $(this).attr('id');

            // find map marker in markers array with the same title
            var markerToClick;
            $.each(markers, function (i, marker) {
                if (marker.id == titleToFind) {
                    markerToClick = markers[i];
                }
            });

            new google.maps.event.trigger(markerToClick, 'click');
        });

        // Sets the map on all markers in the array.
        function setMapOnAll(map) {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(map);
            }
        }

        // Removes the markers from the map, but keeps them in the array.
        function clearMarkers() {
            setMapOnAll(null);
        }

        // Deletes all markers in the array by removing references to them.
        function deleteMarkers() {
            clearMarkers();
            markers = [];
        }

    }

}
